//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import VStyle from '@/components/modules/common/VStyle.vue';

export default {
  name: 'section-lottie-demo',
  components: {
    'v-style': VStyle,
    LottieDemoSwiperSlides: () => import('./LottieDemoSwiperSlides.vue'),
    LottiePlayer: () => import('@motionelements/core/src/components/ui/players/BaseLottiePlayer.vue'),
  },
  computed: {
    ...mapState({
      windowWidth: state => state.browser.window.width,
    }),
    lottieBgColor() {
      return `hsl(${this.lottieBg.hue},${this.lottieBg.saturation}%,${this.lottieBg.lightness}%)`;
    },
    colorPicker() {
      // hsl: { h: 150, s: 0.5, l: 0.2, a: 1 },
      return `hsl: {h: ${this.lottieBg.hue}, s: ${this.lottieBg.saturation / 100},l: ${this.lottieBg.lightness / 100}, a: 1)`;
    },
  },
  data() {
    return {
      activeNumber: 0,
      timer: null,
      count: 3,
      color: {
        h: 0,
        s: 0,
        l: 0,
      },
      swiperOptions: {
        slidesPerView: 1,
        loop: true,
        grabCursor: true,
        autoplay: {
          delay: 5000,
        },
      },
      lottieBg: {
        hue: 193,
        saturation: 75,
        lightness: 10,
      },
      animationTypes: [
        {
          path: 'https://static.moele.me/img/lottie/channel/me-logo-inverse-lottie-220513.json',
        },
        {
          path: 'https://static.moele.me/img/lottie/channel/mobile-animation-hearts.json',
        },
        {
          path: 'https://static.moele.me/img/lottie/channel/video-generate.json',
        },
      ],
      animationSpeed: 1,
      anim: [],
    };
  },
  watch: {
    animationSpeed(value) {
      for (var i = 0; i < this.anim.length; i += 1) {
        this.anim[i].setSpeed(value);
      }
    },
  },
  methods: {
    registerAnimation: function (anim) {
      anim.setSpeed(this.animationSpeed);
      this.anim.push(anim);
    },
  },
};
